import React from 'react';

const TipsSection = () => (
  <div className="mt-6 sm:mt-8 p-3 sm:p-4 bg-blue-50 rounded-xl sm:rounded-2xl">
    <h3 className="text-xs sm:text-sm font-medium text-blue-800 mb-2">Tips for Pitch Deck</h3>
    <ul className="text-xs sm:text-sm text-blue-700 space-y-1.5 sm:space-y-2">
      <li>• Keep your pitch deck concise (10-15 slides)</li>
      <li>• Include key sections: Problem, Solution, Market, Business Model, Team, Financials</li>
      <li>• Use high-quality visuals and minimal text</li>
      <li>• Ensure all data is current and accurate</li>
      <li>• File size should be under 10MB for optimal sharing</li>
    </ul>
  </div>
);

export default TipsSection; 